<template>
    <div class="overlay">
        <div class="container">
           <div class="back-btn" @click="close">
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35"><g transform="translate(-355 -76)"><path class="back-btn-svg" d="M31.223,12.575H18.293l2.424-2.632a5.283,5.283,0,0,0,0-7.018h0l-1.293-1.4a4.333,4.333,0,0,0-6.465,0h0L6.011,9.066a64.368,64.368,0,0,1-4.848,5.263,4.951,4.951,0,0,0,0,6.491l4.848,5.263,6.949,7.544a4.333,4.333,0,0,0,6.465,0h0l1.293-1.4a5.283,5.283,0,0,0,0-7.018h0l-2.424-2.632H31.223A3.823,3.823,0,0,0,34.94,18.54V16.786A3.784,3.784,0,0,0,31.223,12.575Z" transform="translate(355.05 75.925)"/></g></svg>
           </div>
            <div class="content">
                <div v-if="popAgreementValue === 'ntc'" style="padding: 0">
                    <iframe src="https://www.plotiobullion.com/media/pdf/notice_and_agreement_hk_tc.pdf" frameborder="0"></iframe>
                    <div class="download-btn"><a href="https://www.plotiobullion.com/media/pdf/notice_and_agreement_hk_tc.pdf" target="_blank">如出現顯示問題，請按此開新分頁閱瀏或下載。</a></div>
                </div>
                <div v-if="popAgreementValue === 'rds'" style="padding: 0">
                    <iframe src="https://www.plotiobullion.com/media/pdf/risk_disclosure_hk_tc.pdf" frameborder="0"></iframe>
                    <div class="download-btn"><a href="https://www.plotiobullion.com/media/pdf/risk_disclosure_hk_tc.pdf" target="_blank">如出現顯示問題，請按此開新分頁閱瀏或下載。</a></div>
                </div>
                <div v-if="popAgreementValue === 'ggtrar'" style="padding: 0">
                    <iframe src="https://www.plotiobullion.com/media/pdf/general_guidelines_and_trading_rules_tc.pdf" frameborder="0"></iframe>
                    <div class="download-btn"><a href="https://www.plotiobullion.com/media/pdf/general_guidelines_and_trading_rules_tc.pdf" target="_blank">如出現顯示問題，請按此開新分頁閱瀏或下載。</a></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "popAgreement",
        props:{
            popAgreementValue: String,
            close: Function
        },
        data: () => ({

        }),
        components: {
        }
    }
</script>

<style lang="scss">
</style>
